const attrs = {
  name: "Default Set",
  query_parameters: [],
  firebase_enabled: false,
  firebase_host: "",
  firebase_parameter: [],
};

const options = {
  pathName: "sets",
  parentType: "spaces",
  parentKey: "space_id",
};

const getters = {
  queryMap: (state) => state.content[0] || {},
  urlMapFieldIds: (state) => {
    const queryMap = state.content && state.content[0];
    if (!queryMap || !queryMap.query_parameters) return [];

    let nested = state.content[0].query_parameters.map((field) => {
      return field.template
        .filter((parameter) => parameter.type === "field")
        .map((parameter) => {
          return parameter.value;
        });
    });

    state.content[0].firebase_parameter = state.content[0].firebase_parameter
      ? state.content[0].firebase_parameter
      : [];
    let nested_firebase = state.content[0].firebase_parameter.map((field) => {
      return field.template
        .filter((parameter) => parameter.type === "field")
        .map((parameter) => {
          return parameter.value;
        });
    });
    const parameter_field_ids = [].concat.apply([], nested);
    const all_field_ids = parameter_field_ids.concat.apply(
      parameter_field_ids,
      nested_firebase
    );
    return all_field_ids;
  },
};

export default {
  generic: {
    attrs,
    options,
  },
  getters,
};
